module.exports = {
  SELECT_EACH_TIME: "S",
  CREATE_OWN_INVOICE: "C",
  GENERATE_INVOICE_ONLINE: "G",
};
